import { IMember } from "@/models/Member.model";

const state = { members: [], committee: [], invitedSpeakers: [] };
const getters = {
  // @ts-ignore
  getOrganizingCommittee: (state) =>
    // @ts-ignore
    state.committee.filter(
      // @ts-ignore
      (member) =>
        member.isInternationalCommittee == true ||
        member.isLocalCommittee == true
    ),
  // @ts-ignore
  getScientificCommittee: (state) =>
    // @ts-ignore
    state.committee.filter((member) => member.isScientificCommittee == true),
  // @ts-ignore
  getInvitedSpeakers: (state) =>
    // @ts-ignore
    state.invitedSpeakers,
  // @ts-ignore
  getChairman: (state) =>
    state.committee.find(
      // @ts-ignore
      (member) => member.isChairman == true
    ),
  // @ts-ignore
  getCoChairman: (state) =>
    state.committee.find(
      // @ts-ignore
      (member) => member.isCoChairman == true
    ), // @ts-ignore
  getHonoraryChairman: (state) =>
    state.committee.find(
      // @ts-ignore
      (member) => member.isHonoraryChairman == true
    ),
  // @ts-ignore
  getScientificCommitteeChairman: (state) =>
    state.committee.find(
      // @ts-ignore
      (member) => member.isScientificCommitteeChairman == true
    ),
  // @ts-ignore
  getMainOrganizer: (state) =>
    state.committee.find(
      // @ts-ignore
      (member) => member.isMainOrganizer == true
    ),
};

const mutations = {
  // @ts-ignore
  setCommittee(state, committee: IMember[]) {
    state.committee = committee;
  },
  // @ts-ignore
  setInvitedSpeakers(state, invitedSpeakers: IMember[]) {
    state.invitedSpeakers = invitedSpeakers;
  },
};

const actions = {};

export default { state, getters, mutations, actions };
